var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepositAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7hxk2n6z5a",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "58yftaohsc",
    d: "M1.037 21.893 0 .357 23.621 0l12.17 15.567 2.648 13.747-9.185 8.611z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "452j25no8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7hxk2n6z5a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#452j25no8b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    d: "M21.002.036v23.671M24.157 10.556l.064 32.345M47.98 39.666v15.413M52.165 46.704v15.412"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.93 10.562)",
    stroke: "#0E1D31",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.276 6.126c2.55-1.591 4.276-2.503 5.181-2.734 1.358-.348 4.818-.23 7.589 1.415 2.771 1.645 4.91 3.705 7.878 7.579 2.968 3.873 4.746 8.468 5.44 11.519.944 4.15.423 7.866-.443 9.366-.578 1-2.243 2.475-4.997 4.427L9.276 6.126z",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.972 5.394 2.996-1.722M19.96 7.204l2.93-1.81M23.243 9.604l2.583-1.856M25.541 11.938l2.618-1.716M27.742 14.416l2.403-1.661M29.149 16.743l2.659-1.337M30.854 19.923l2.858-.773M32.283 22.885l2.638-.744M33.101 26.375l2.464-.629M33.602 29.756l2.265-.659M33.101 32.411l2.464-.393"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-33 19.62 21.88)",
    cx: 19.619,
    cy: 21.881,
    rx: 10.575,
    ry: 18.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-33 19.593 21.912)",
    cx: 19.593,
    cy: 21.912,
    rx: 8.188,
    ry: 14.553
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 37.072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.046 4.876C-.246 2.999.855 1.58 3.349.617 7.09-.826 12.91.484 16.321 2.256c2.274 1.181 16.992 9.531 44.154 25.051v49.278L.046 42.34V4.876z",
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#CCE7EC",
    d: "m1.98 8.31 8.305-5.39 46.21 26.916V73.01l-9.997 5.267L2.552 11.213z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    d: "M4.956 6.396 51.35 32.722v43.012"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    d: "m7.5 4.876 46.486 26.577V74.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#99CFD9",
    d: "M60.475 46.144 62 47.358l-1.525.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.046 4.876v50.963l47.671 27.089V34.46C20.817 19.088 6.262 10.789 4.053 9.565 1.844 8.34.51 6.777.046 4.876z",
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#E5F2F5",
    d: "M47.717 55.332v10.01L62 56.86v-9.502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 47.358v9.502l-14.283 8.482-7.696-4.53c-1.755-1.206-2.632-3.176-2.632-5.907 0-4.098 2.55-3.953 3.192-3.566.427.258 2.806 1.589 7.136 3.993L62 47.358z",
    stroke: "#0E1D31",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0086A0",
    transform: "rotate(-47 41.767 56.691)",
    cx: 41.767,
    cy: 56.691,
    rx: 1.925,
    ry: 2.407
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.926 25.966)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nup9i3ezod",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#58yftaohsc"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#nup9i3ezod)",
    stroke: "#0E1D31",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.229 -1.649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.276 6.126c2.55-1.591 4.276-2.503 5.181-2.734 1.358-.348 4.818-.23 7.589 1.415 2.771 1.645 4.91 3.705 7.878 7.579 2.968 3.873 4.746 8.468 5.44 11.519.944 4.15.423 7.866-.443 9.366-.578 1-2.243 2.475-4.997 4.427L9.276 6.126z",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.972 5.394 2.996-1.722M19.96 7.204l2.93-1.81M23.243 9.604l2.583-1.856M25.541 11.938l2.618-1.716M27.742 14.416l2.403-1.661M29.149 16.743l2.659-1.337M30.854 19.923l2.858-.773M32.283 22.885l2.638-.744M33.101 26.375l2.464-.629M33.602 29.756l2.265-.659M33.101 32.411l2.464-.393"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-33 19.62 21.88)",
    cx: 19.619,
    cy: 21.881,
    rx: 10.575,
    ry: 18.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-33 19.593 21.912)",
    cx: 19.593,
    cy: 21.912,
    rx: 8.188,
    ry: 14.553
  })))), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#E5F2F5",
    transform: "rotate(-26 21.807 80.328)",
    cx: 21.807,
    cy: 80.328,
    rx: 9.618,
    ry: 14.863
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#0E1D31",
    strokeWidth: 0.7,
    fill: "#CCE7EC",
    transform: "rotate(-26 21.79 80.676)",
    cx: 21.789,
    cy: 80.676,
    rx: 7.729,
    ry: 11.981
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#0E1D31",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.101 87.131c.243.465.452.759.628.881.175.123.483.123.923 0v-.69l-1.551-.19z",
    fill: "#0E1D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.113 83.458c.02 1.823.136 2.885.346 3.186.315.453 2.39 1.735 2.733 1.53.23-.137.321-1.097.276-2.878.04-.81.22-1.319.543-1.526.484-.312 1.572-1.333 1.695-2.506.122-1.173-.388-3.394-1.695-5.171-1.307-1.777-2.753-2.539-4.252-2.539-1.037 0-2.025 1.353-2.025 2.78 0 2.91 1.268 3.563 2.025 5.515.236.609.354 1.145.354 1.61z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.113 83.458c.02 1.823.136 2.885.346 3.186.315.453 2.39 1.735 2.733 1.53.23-.137.321-1.097.276-2.878l-3.355-1.838z",
    fill: "#66B6C6"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositAlert);
export default __webpack_public_path__ + "static/media/deposit-alert.c6830ea4.svg";
export { ForwardRef as ReactComponent };